import React, { FunctionComponent, useState } from 'react';
import { Box, Paper, makeStyles, Grid, createStyles, Theme } from '@material-ui/core';
import Loader from '../../../../components/Loader';
import EmptyRecord from '../../../../components/TableView/TableEmptyState';
import AddCommentField from '../../../../components/AddCommentField';
import CommentInfiniteScroll from '../../../../components/CommentInfiniteScroll';

type CommentProps = {
    data: any;
    application: any;
    addComment: Function;
    loading: Boolean;
    skip: number;
    setSkip: Function;
    hasMore: boolean;
    doShowDetail?: boolean;
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        commentInnerGrid: {
            width: '100%',
            marginTop: '40px',
            display: 'grid',
            justifySelf: 'center',
        },
        commentOuterGrid: {
            height: '100%',
            width: '100%',
            display: 'grid',
            gridTemplateRows: 'auto 1fr',
            padding: '20px',
        },
        paper: {
            width: '75%',
            height: '100%',
            overflow: 'hidden',
        },
        container: {
            display: 'flex',
            justifyContent: 'center',
            height: '100%',
        },
        addCommentButton: {
            backgroundColor: theme.palette.primary.light,
            color: 'white',
            padding: '6px 10px 6px 10px',
            marginRight: '4px',
            '&:hover': {
                backgroundColor: theme.palette.primary.main,
            },
        },
        commentTextField: {
            marginBottom: '15px',
        },
        comments: {
            marginTop: '30px',
            display: 'grid',
        },
    }),
);

const Comment: FunctionComponent<CommentProps> = (props) => {
    const { data, application, addComment, loading, hasMore, skip, setSkip, doShowDetail } = props;
    const [isAddLicenseCommentOpen, setAddLicenseCommentOpen] = useState<boolean>(false);
    const [comment, setComment] = useState('');
    const handleChangeComment = (event: React.ChangeEvent<{ name?: string; value: string }>) => {
        setComment(event.target.value);
    };

    const handleAddComment = () => {
        const newPayload = {
            text: comment,
            licenseId: application.id,
        };
        addComment(newPayload);
        setComment('');
        setAddLicenseCommentOpen(false);
    };

    const loadMore = () => {
        if (hasMore) {
            setSkip(skip + 1);
        }
    };

    const classes = useStyles();

    if (loading) {
        return <Loader />;
    }

    return (
        <div className={classes.container}>
            <Paper className={classes.paper}>
                <Grid container className={classes.commentOuterGrid}>
                    <AddCommentField
                        isAddCommentFieldOpen={isAddLicenseCommentOpen}
                        setAddCommentFieldOpen={setAddLicenseCommentOpen}
                        setComment={setComment}
                        handleAddCommentChange={handleAddComment}
                        handleChangeComment={handleChangeComment}
                        disabled={!!comment ? false : true}
                    />
                    <Box className={classes.comments}>
                        {data && data.length > 0 ? (
                            <CommentInfiniteScroll
                                loadMore={loadMore}
                                hasMore={hasMore}
                                data={data}
                                scrollableTarget="licenseComment"
                                doShowDetail={doShowDetail}
                            />
                        ) : (
                            <Box>
                                <EmptyRecord title="No active records for this license. " message=" " />
                            </Box>
                        )}
                    </Box>
                </Grid>
            </Paper>
        </div>
    );
};

export default Comment;
